import { render } from "./SelectCurrentSite.vue?vue&type=template&id=f763c1fc"
import script from "./SelectCurrentSite.vue?vue&type=script&lang=js"
export * from "./SelectCurrentSite.vue?vue&type=script&lang=js"
script.render = render

export default script